import * as constants from "@client/constants";
import * as React from "react";
import ReactMarkdown from "react-markdown";

interface UserMarkdownProps {
    content: string;
}

export function UserMarkdown(props: UserMarkdownProps) {
    const markdownClassName =
        "*:text-left space-y-3 *:space-y-3 *:list-inside *:list-decimal list-inside-fix";

    return (
        <ReactMarkdown
            className={markdownClassName}
            allowedElements={constants.ALLOWED_MARKDOWN_ELEMENTS}
        >
            {props.content}
        </ReactMarkdown>
    );
}
